{
  "name": "dwolla-v2",
  "version": "3.4.0",
  "description": "Dwolla V2 API client",
  "main": "src/index.js",
  "files": [
    "src/**/*.js",
    "src/*.js",
    "src/*.d.ts"
  ],
  "scripts": {
    "test": "NODE_ENV=test mocha test/**",
    "eslint": "eslint src/ test/",
    "prettier-check": "npm run _prettier -- --check",
    "prettier-write": "npm run _prettier -- --write",
    "_prettier": "prettier src/*.js src/**/*.js test/*.js test/**/*.js"
  },
  "keywords": [
    "Dwolla"
  ],
  "author": "Stephen Ausman <stephen@dwolla.com>",
  "license": "MIT",
  "devDependencies": {
    "chai": "^4.1.2",
    "chai-as-promised": "^7.1.1",
    "eslint": "^5.13.0",
    "form-data": "^2.5.0",
    "mocha": "^6.2.3",
    "nock": "^9.6.1",
    "prettier": "^1.18.2",
    "sinon": "^6.1.5"
  },
  "dependencies": {
    "bluebird": "^3.5.1",
    "form-urlencoded": "^4.5.1",
    "invariant": "^2.2.4",
    "is-stream": "^1.1.0",
    "lodash.snakecase": "^4.1.1",
    "node-fetch": "^2.6.2"
  }
}
